import React from 'react';
import '../CSS/Collaboration.css'
import Pages from './Pages.js';





class Collaboration extends Pages {


  componentDidMount() {
    window.scrollTo(0, 0)
  }

  leftmenu = () => {
    return (
      <div className='leftmenu'>
        <div>
          Collaboration
        </div>
        <br />
        <button onClick={() => this.scroll(this.firstRef)} className={'section'}>Tec Chihuahua x HKU iGEM Audiobook</button>
        <button onClick={() => this.scroll(this.secondRef)} className={'section'}>HKU-Thessaly-Manchester-Bath iGEM Policy Forum</button>
        <button onClick={() => this.scroll(this.thirdRef)} className={'section'}>SSC iGEM 2022</button>
        <button onClick={() => this.scroll(this.fourthRef)} className={'section'}>HKIS iGEM 2022</button>
        <button onClick={() => this.scroll(this.fifthRef)} className={'section'}>Instagram meme collaboration</button>
        <button onClick={() => this.scroll(this.sixthRef)} className={'section'}>Regional Symposium</button>
        <button onClick={() => this.scroll(this.seventhRef)} className={'section'}>iGEM Phototroph community</button>


      </div>
    )
  }

  righttext = () => {
    return (
      <div className='righttext'>
        {/* 1. Understanding the Problem */}
        <h2 ref={this.firstRef}> Tec Chihuahua x HKU iGEM Audiobook</h2>
        <div>
          <br />
          This year, we set our eyes on making synthetic biology accessible to everyone - specifically targeting persons of less scientific and literate backgrounds. We saw an opportunity to use our multilingualism within and around iGEM teams to create a synthetic biology audiobook.
          <br /><br />
          Together with iGEM Tec Chihuahua, we co-created and co-produced an audiotaped storybook. Through story-telling, we hope to engage inexperienced learners regardless of their familiarity with science and biology. Deliberately incorporating day-to-day vocabularies and analogies, we aimed to tailor our audiobook to be accessible to a diverse audience regardless of their proficiency in science, literacy and linguistic abilities.
          <br /><br />
          Our final audiobook has 5 short stories and a 3-chapter sequel about synthetic biology applications around us and the projects developed by the authoring teams.
          To broaden our reach, we aim to launch the audiobook online and translate it into at least 4 languages (English, Cantonese, Mandarin and Español). Unlike a traditional paperback storybook, by keeping our audiobook accessible over the internet for free helps cross over socio-economic and geographical boundaries. We hope that our audiobook helps inspire our audiences and propagate science as being accessible and inclusive to all.
          <br /><br />
          You can access the audiobook on Spotify and Youtube: <br /><br />
          Youtube: <a href='https://youtu.be/yEqRbgNZQFk ' target="_blank" rel="noreferrer" >https://youtu.be/yEqRbgNZQFk </a><br />
          Spotify: <a href={'https://open.spotify.com/show/2MXxAdtckNBKcFQTR9O3Wo '} target="_blank" rel="noreferrer" >https://open.spotify.com/show/2MXxAdtckNBKcFQTR9O3Wo</a>


        </div>
        <div >
          <br />

          <i><b> First meeting with the Tech Chihuahua team <br /></b></i>
          <br />
          <img src={'https://static.igem.wiki/teams/4241/wiki/collab/collab.png'} alt='' style={{ width: '100%' }} />
        </div>
        <br />
        <h2 ref={this.secondRef}> HKU-Thessaly-Manchester-Bath iGEM Policy Forum </h2>
        <div>
          <br />
          In collaboration with iGEM teams across the continent - iGEM Thessaly from Greece, iGEM Manchester and iGEM Bath from the United Kingdom - we organized and hosted a policy symposium to review policies and regulations governing synthetic biology in our jurisdictions. With guest experts invited to participate in our discussion, we aimed to reflect and discuss regulations and policies affecting the projects of the participating teams.
          <br /><br />
          Participant iGEM teams shared about the development and enforcement of regulations, and discussed the perceptions and attitudes of our governments towards synthetic biology in general. Teams shared their take on how they expected their projects to be received from legal and societal perspectives. The cross-jurisdiction comparison, consultations with regional representatives and analysis of legal documents helped guide the development of our project and enhance the prospect of real-world application.
          <br /><br />
          <i><b> First meeting with the Manchester, Bath, and Thessaly team <br /></b></i>
          <img src={'https://static.igem.wiki/teams/4241/wiki/collab/first-meeting.png'} alt='' style={{ width: '100%' }} /><br />
          <br /><br />
          <i><b> Event Day <br /></b></i>
          <img src={'https://static.igem.wiki/teams/4241/wiki/collab/screenshot-2022-09-13-at-10-47-13-pm.png'} alt='' style={{ width: '100%' }} /><br />
          <img src={'https://static.igem.wiki/teams/4241/wiki/symposium-1.png'} alt='' style={{ width: '100%' }} /><br />
          <br /><br />
          <i><b> Team presentations <br /></b></i>
          <img src={'https://static.igem.wiki/teams/4241/wiki/collab/screenshot-2022-09-13-at-10-06-52-pm.png'} alt='' style={{ width: '100%' }} /><br />

          For the policy forum, HKU iGEM 2022 researched local laws and policies on production, implementation of GMOs in Hong Kong, such as the Proposed “PMSAS” scheme, Public Health and Municipal Services Ordinance, Chapter 132, Part V. During the policy forum, we also talked about how after talking to consumers and reading about the policies in Hong Kong, we changed our project from feeding fish with genetically modified microalgae to the implementation of a freeze dried microalgae palette.<br /><br />
          <a href='https://static.igem.wiki/teams/4241/wiki/collab/igem-policy-symposium.pdf' target="_blank" rel="noreferrer" >You can find our slides here. </a>

        </div><br />
        <h2 ref={this.thirdRef}> SSC iGEM 2022</h2><br />
        <div>
          This year, St Stephen's College iGEM Team continued working on last year’s project by synthesizing lactam with synechococcus elongatus. In order to facilitate their project, we provided the SSC team our improved pET-28a construct with enhanced promoter and ribosome binding site. <br />
          <img src={'https://static.igem.wiki/teams/4241/wiki/collab/ssc.png'} alt='' style={{ width: '100%' }} /><br />
        </div><br />
        <h2 ref={this.fourthRef}> HKIS iGEM 2022</h2><br />
        <div>
          This year, we continued the mentorship program between Hong Kong International School’s iGEM team and HKU iGEM 2022. This network continued to grow throughout our project. HKU iGEM continued to provide HKIS with valuable insight into different aspects of their project. Whenever the HKIS team has questions, they will contact our team for assistance. Unfortunately, this year, HKIS iGEM could not register for the competition successfully due to technical difficulties. Nonetheless, they worked relentlessly with our advisor Kenneth Ng to publish their research in an academic journal.
          {/* <div style={{ textAlign: 'center' }}> */}
          <div>
            <i><b> Wet lab training with the HKIS team  <br /></b></i>
            <img src={'https://static.igem.wiki/teams/4241/wiki/collab/16124610-d0ab-468f-81f6-8d47362be1a2.jpeg'} alt='' style={{ width: '100%' }} /><br />
          </div>
        </div><br />

        <h2 ref={this.fifthRef}> Instagram meme collaboration</h2><br />
        <div>
          <br />
          We met with the CUHK iGEM 2022 team during the Hong Kong Regional symposium. Even though we worked on very different topics, we enjoyed each other’s presentations during the symposium. Following the event, our teams decided to work together to launch an iGEM meme campaign on Instagram. Using Instagram Collab features, we post and share entertaining memes and videos that portray our iGEM experience using our meme accounts @igem.clowns and @igemfunguy. <br />
          <div>
            <i><b> Our Meme Page  <br /></b></i>
            <img src={'https://static.igem.wiki/teams/4241/wiki/collab/igem-clowns.png'} alt='' style={{ width: '100%' }} /><br />
            <i><b> Collaboration Post with CUHK iGEM 2022 <br /></b></i>
            <img src={'https://static.igem.wiki/teams/4241/wiki/collab/screenshot-2022-10-12-at-11-44-27-am.png'} alt='' style={{ width: '100%' }} /><br />
          </div>
        </div>
        <br />
        <h2 ref={this.sixthRef}> Regional Symposium</h2><br />
        <div>
          <br />
          HKU iGEM 2022 was honored to have participated in the regional symposium - Sustainable Living through Synbio - hosted by the HKUST iGEM team. Several teams in Hong Kong participated in the symposium, such as CUHK, City U, and CPU-WFN-WYY. Each team had to prepare a 10-minute-long presentation about their respective project. Team HKUST also invited multiple experts in synthetic biology, such as Professor King Chow, Professor Yong Lai, and Professor Fei Sun. The expert’s presentation enlightened us and deepened our understanding of the topic of synthetic biology. <br /><br />
          We particularly enjoyed the mingling session. Through this session, we were able to build a friendship with other teams, as well as communicate our struggles and solutions. This eventually led to further collaboration with the local teams.
          <br /><br />
          We would like to thank HKUST iGEM 2022 for inviting us to the symposium. This symposium was very helpful as the Q&A session provided our team with insights to further improve our project.
          <br /><br />
          <i><b> Regional Symposium hosted by HKUST iGEM 2022  <br /></b></i>
          <img src={'https://static.igem.wiki/teams/4241/wiki/collab/symposium2.jpeg'} alt='' style={{ width: '100%' }} /><br />
        </div><br />
        <h2 ref={this.seventhRef}> iGEM Phototroph community</h2><br />
        <div>
          This year, we also participated in the iGEM Phototroph community, which was co-organized by the iGEM teams at Arizona State University and University of British Columbia - Okanagan Campus. The Phototroph Community was initially started by Marburg and Bielefeld teams in 2021 to provide iGEM teams working with phototrophic chassis a platform to communicate and receive insights on their respective projects. This year ASU and UBCO continued team Marburg and team Bielefeld’s legacy by creating Volume II of the Phototroph Community handbook, to which HKU iGEM 2022 contributed significantly. In Volume II of the Phototroph Community handbook, our team provided detailed information on cloning and transformation and detailed protocols on the growth kinetics of microalgae, particularly Chlorella Autotrophica.  As a member of the iGEM Phototroph community, we also attended the community's first and second meeting. During the first meeting, we presented our project to fellow members in the community and received valuable feedback on how to further improve our project. We were also inspired by other team's project and the work they have done. During the second meeting, ASU and UBCO hosted a troubleshooting session and invited experts in plants, cloning, and algae. The sessions really benefited our team, thus we would like to thank ASU and UBCO once again for organizing the events.

          <br /><br />
          <i><b> iGEM Phototroph community first meeting <br /></b></i>
          <br /><br />

          <img src={'https://static.igem.wiki/teams/4241/wiki/collab/collabzoomscreenshotasuigem-1.png'} alt='' style={{ width: '100%' }} /><br />

        </div>




      </div>
    )
  }

  render() {
    return (
      <>
        {/* {this.state.isLoading ? <div className='load-container'><BarLoader color={'silver'} size={150} loading={this.state.isLoading} cssOverride={CSSRef} /></div> : null} */}
        <h1 className='des' ref={this.pageRef}>
          Collaboration
        </h1>
        <div className='pageholder'>
          {this.leftmenu()}
          {this.righttext()}
        </div>
      </>
    );
  }
}


export default Collaboration;
